import { makeStyles, Box, TextField } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AboutLoggingTooltip from 'src/components/AboutLoggingTooltip';
import { RootState } from 'src/store';
import { editBtnAgain } from 'src/store/modules/buttons';
// import { editRadius } from 'src/store/modules/imageUpload';

interface radiusProps {
  menuTitle: string;
  type: string;
  max: number;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: '20px 16px',
    paddingTop: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },

  radiusWrapper: {
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'row',
    gap: '8px',
    alignItems: 'center',
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    color: '#191F28',
    transition: 'all 0.2s ease',
    '&:hover': {
      color: '#4E5968'
    }
  },
  radius: {
    width: '20px',
    height: '20px',
    padding: '3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1.5px solid #E5E8EB',
    borderRadius: '50%',
    transition: 'all 0.2s ease'
  },
  radiusAct: {
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    backgroundColor: '#191F28'
  },

  input: {
    height: '44px',
    padding: '12px',
    outline: 'none',
    overflow: 'hidden',
    border: '1px solid #E5E8EB',
    borderRadius: '8px',
    backgroundColor: '#F7F8FA',
    '&:focus': {
      borderColor: '#191F28',
      outline: 'none'
    }
  },
  inputRoot: {
    padding: 0,
    height: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  inputText: {
    fontFamily: "'Poppins', sans-serif",
    fontSize: '13px',
    fontWeight: 400,
    lineHeight: '1.5',
    color: '#191F28'
  }
}));

const EditBtnAgain: any = ({ menuTitle, type }: any) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const [key, setKey] = useState(false);
  const handleKey = e => {
    if (e.key === 'Enter') setKey(true);
    else setKey(false);
  };
  const handleBtnAgain = e => {
    const textSplit = e.target.value.split('');
    if (
      textSplit[textSplit.length - 1] === '\\' ||
      textSplit[textSplit.length - 1] === '"'
    )
      return;
    const newBtnAgain = { [type]: e.target.value };
    dispatch(editBtnAgain({ ...btnAgain, ...newBtnAgain }));
  };

  const handleClickInput = (type: any) => {
    if (btnAgain?.type === type) {
      const newBtnAgain = JSON.parse('{"type": "none"}');
      dispatch(editBtnAgain({ ...btnAgain, ...newBtnAgain }));
    } else {
      // const newBtnAgain = JSON.parse(`{"type": "${type}"}`);
      const newBtnAgain = { type };

      dispatch(editBtnAgain({ ...btnAgain, ...newBtnAgain }));
    }
  };

  return (
    <div className={classes.root}>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <div
          style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: '13px',
            fontWeight: 600,
            color: '#191F28',
            letterSpacing: '0.02em'
          }}
        >
          {/* {menuTitle} */}
          LOGGING
        </div>
        <AboutLoggingTooltip />
      </div>

      <Box
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem'
        }}
      >
        <Box
          className={classes.radiusWrapper}
          onClick={() => handleClickInput('attribute')}
        >
          <Box className={classes.radius}>
            {btnAgain?.type === 'attribute' && (
              <Box className={classes.radiusAct} />
            )}
          </Box>
          <span>Log Custom Attribute</span>
        </Box>
        {btnAgain?.type === 'attribute' && (
          <TextField
            className={classes.input}
            id="standard-multiline-flexible"
            //   multiline
            InputProps={{
              classes: {
                root: classes.inputRoot,
                input: classes.inputText
              },
              disableUnderline: true
            }}
            value={btnAgain?.[type]}
            onChange={handleBtnAgain}
            onKeyPress={handleKey}
          />
        )}

        <Box
          className={classes.radiusWrapper}
          onClick={() => handleClickInput('event')}
        >
          <Box className={classes.radius}>
            {btnAgain?.type === 'event' && (
              <Box className={classes.radiusAct} />
            )}
          </Box>
          <span>Log Custom Event</span>
        </Box>
        {btnAgain?.type === 'event' && (
          <TextField
            className={classes.input}
            id="standard-multiline-flexible"
            //   multiline
            InputProps={{
              classes: {
                root: classes.inputRoot,
                input: classes.inputText
              },
              disableUnderline: true
            }}
            value={btnAgain?.[type]}
            onChange={handleBtnAgain}
            onKeyPress={handleKey}
          />
        )}
      </Box>
    </div>
  );
};
export default EditBtnAgain;
